export default "__VITE_ASSET__DfbUxM3k__"